import React, {useEffect} from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import Button from '@mui/material/Button';
import classes from './VerifyEmail.module.scss'
import Layout from '../layout/Layout'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate, useLocation } from '@reach/router'
import {verifyEmail, changeEmail} from './AccountAPI'
import useTitle from '../../hooks/title';


const SuccessResult = observer(({ctrl}) => {

  return <>
    <CheckCircleOutlineIcon className={classes.successIcon} />
    <div className={classes.resultInfo}>Your email address has been verified</div>
    <Button variant="contained" disableElevation className={classes.resultButton} onClick={ctrl.toHome}>Continue to Browse</Button>
  </>
})

const FailResult = observer(({ctrl}) => {

  return <>
    <ErrorOutlineIcon className={classes.failIcon} />
    <div className={classes.resultInfo}>Access ticket expried</div>
    <Button variant="contained" disableElevation className={classes.resultButton} onClick={ctrl.toHome}>Continue to Browse</Button>
  </>
})

const VerifyEmail = observer(({path}) => {
  const location = useLocation();
  const navigate = useNavigate()
  useTitle(path == '/auth/change-email' ? 'Change Email' : 'Verify Email')

  const ctrl = useLocalObservable(() => ({
    result: null,
    loading: false,
    async load(ticket) {
      try {
        this.loading = true
        // await verifyTicket({ticket})
        if (path == '/auth/change-email') {
          await changeEmail({ticket})
        }
        else if (path == '/auth/verify-email') {
          await verifyEmail({ticket})
        }
        else {
          navigate('/', {replace: true})
        }
        this.result = 'success'
      } catch (e) {
        console.error('reset fail', e)
        this.result = 'fail'
      } finally {
        this.loading = false
      }
    },
    toHome() {
      navigate('/', {replace: true})
    }
  }))

  useEffect(() => {
    const query = new URLSearchParams(location.search)
    const ticket = query.get('ticket')
    if (!ticket) {
      navigate('/', {replace: true})
      return;
    }
    ctrl.load(ticket)
  }, [ctrl.load, location])

  return <Layout>
  <div className={classes.root}>
    {ctrl.result == 'success' ? <SuccessResult ctrl={ctrl} /> : <FailResult ctrl={ctrl} />}
  </div>
</Layout>
})

export default VerifyEmail